import { render, staticRenderFns } from "./GemiTipiPicker.vue?vue&type=template&id=c25480b4"
import script from "./GemiTipiPicker.vue?vue&type=script&lang=ts"
export * from "./GemiTipiPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports